import { AxiosResponse } from "axios";
import { saveAs } from "file-saver";

// TODO:: maybe change type
import { Attachment } from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { HttpClient } from "src/http/httpClient.ts";

export type AttachmentConfig = {
  maxContentLength: number;
  mimeTypes: Record<string, string>;
  extensions: string[];
};

export type ServerFolderData = {
  id: string;
  name: string;
  createdAt: string;
};

export type ServerUploadFileData = {
  id: string;
  fileId: ServerFolderData;
};

export class AttachmentsApi {
  constructor(private readonly path: string) {}

  static Attachments() {
    return new AttachmentsApi("/v1/attachment");
  }

  async getConfig(): Promise<AttachmentConfig> {
    const result = await HttpClient.instance.get<AttachmentConfig>(this.path + "/config");
    return {
      ...result.data,
      extensions: Object.values(result.data.mimeTypes)
        .reduce<string[]>((acc, extensions) => [...acc, ...extensions], [])
        .map((e) => `.${e}`),
    };
  }

  async getAttachment(attachment: Attachment) {
    const response = await HttpClient.instance.get(`${this.path}/${attachment.id}`, {
      responseType: "blob",
      headers: {
        Accept: attachment.contentType,
      },
    });

    if (response.data && response.status === 200) {
      saveAs(response.data, attachment.name);
    }
  }

  async uploadAttachment(
    attachableId: string,
    file: File
  ): Promise<AxiosResponse<ServerUploadFileData>> {
    const formData = new FormData();
    formData.append("file", file as Blob);
    return HttpClient.instance.post<ServerUploadFileData>(this.path, formData, {
      params: {
        attachableId,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
